import React, { Component } from 'react';
import PropTypes from 'prop-types';
import enhanceWithClickOutside from 'react-click-outside';
import { Field, reduxForm } from 'redux-form';
import NumberFormat from 'react-number-format';
import { Dropdown, MenuItem, FormGroup, ControlLabel, FormControl, HelpBlock, Button } from 'react-bootstrap';
import Joi from 'joi';

import styles from './styles.css';
import MoneyDisplay from '../../../../components/money-display';

class SalesGoalSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    this.renderNumericField = this.renderNumericField.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleClickOutside() {
    this.setState({ open: false });
  }

  handleSubmit(data) {
    if (data.salesGoal !== this.props.salesGoal) {
      this.props.onSalesGoalChange(data.salesGoal);
      this.handleClickOutside();
    }
  }


  handleToggle(open, e, s) {
    if (open) {
      if (!this.state.open) {
        this.props.initialize({ salesGoal: `${this.props.salesGoal !== 0 ? this.props.salesGoal : ''}` }); // reset the form when open
      }
      this.setState({ open });
    } else if (this.state.open && s.source === 'rootClose') {
      this.handleClickOutside();
    }
  }

  renderNumericField({
    input, label, placeholder, className, thousandSeparator, meta: { touched, error },
  }) {
    const { organization } = this.props;
    let fieldPrefix = null;
    let fieldSuffix = null;
    if (organization) {
      fieldSuffix = organization.currency_suffix;
      fieldPrefix = organization.currency_symbol;
    }

    const validationState = touched && error ? 'error' : null;
    const value = Number.isNaN(input.value) ? '' : input.value;
    return (
      <FormGroup validationState={validationState} className={className}>
        <ControlLabel>{label}</ControlLabel>
        <div className="input-group">
          {fieldPrefix && <span className="input-group-addon">{fieldPrefix}</span>}
          <NumberFormat
            value={value}
            thousandSeparator={thousandSeparator}
            className="form-control"
            placeholder={placeholder}
            onValueChange={(values) => {
              this.props.change(input.name, parseFloat(values.value));
              this.props.touch(input.name);
            }}
          />
          {fieldSuffix && <span className="input-group-addon">{fieldSuffix}</span>}
        </div>
        {touched && error && <HelpBlock>{error.join('. ')}</HelpBlock>}
      </FormGroup>
    );
  }
  renderLabel() {
    const { salesGoal, organization } = this.props;
    return (
      <MoneyDisplay value={salesGoal} abbreviated precision={2} organization={organization} />
    );
  }

  renderInput() {
    const {
      handleSubmit, valid, dirty,
    } = this.props;
    return (
      <li
        className={styles.wrapper}
      >
        <div>
          <form onSubmit={handleSubmit(this.handleSubmit)}>
            <Field
              name="salesGoal"
              type="text"
              component={this.renderNumericField}
              label="Sales Goal"
              placeholder="enter sales goal"
              thousandSeparator
            />
            <Button bsStyle="primary" block bsSize="sm" disabled={!valid || !dirty} type="submit">Apply</Button>
          </form>
        </div>
      </li>
    );
  }

  render() {
    const { disabled } = this.props;
    const { open } = this.state;
    return (
      <Dropdown
        disabled={disabled}
        id="dropdown-ranges"
        onToggle={this.handleToggle}
        open={open}
      >
        <Dropdown.Toggle disabled={disabled}>
          {this.renderLabel()}
        </Dropdown.Toggle>
        <Dropdown.Menu className={styles.dropdown}>
          {this.renderInput()}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

SalesGoalSelector.propTypes = {
  initialize: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  touch: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  valid: PropTypes.bool.isRequired,
  salesGoal: PropTypes.number,
  disabled: PropTypes.bool,
  dirty: PropTypes.bool.isRequired,
  organization: PropTypes.shape({}),
  onSalesGoalChange: PropTypes.func,
};

SalesGoalSelector.defaultProps = {
  salesGoal: 0,
  disabled: false,
  organization: null,
  onSalesGoalChange: () => {},
};

const validate = (data) => {
  // Legacy constraints for reference:
  // const constraints = {
  //   salesGoal: {
  //     presence: true,
  //     numericality: { greaterThanOrEqualTo: 0, strict: true },
  //   },
  // };

  const schema = Joi.object({
    salesGoal: Joi.number().min(0).required().messages({
      'number.base': 'Sales goal must be a number',
      'number.min': 'Sales goal must be at least 0',
      'any.required': 'Sales goal is required',
    }),
  }).unknown(true);

  const { error } = schema.validate(data, { abortEarly: false });
  if (!error) return {};
  
  return error.details.reduce((acc, curr) => {
    if (!acc[curr.path[0]]) acc[curr.path[0]] = [];
    acc[curr.path[0]].push(curr.message);
    return acc;
  }, {});
};

const ModalSliderForm = reduxForm({
  form: 'modalSalesGoalForm',
  validate,
})(SalesGoalSelector);

export default enhanceWithClickOutside(ModalSliderForm);
